import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

// PC用ヘッダーのStimulus Controller
app.register('refosumu--site-header', class extends Controller {
  static targets = ['companyDropdown', 'subsidyDropdown', 'columnDropdown', 'prefecturesContainer']

  connect() {
    // ドロップダウン外をクリックしたときに閉じる
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener('click', this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    // ヘッダー内のクリックは無視
    if (this.element.contains(event.target)) {
      return
    }
    // すべてのドロップダウンを閉じる
    this.closeAllDropdowns()
  }

  toggleCompanyDropdown(event) {
    event.stopPropagation()
    const navItem = event.currentTarget.closest('.site-header__nav-item')
    const isVisible = this.hasCompanyDropdownTarget && this.companyDropdownTarget.style.display === 'flex'

    this.closeAllDropdowns()

    if (!isVisible && this.hasCompanyDropdownTarget) {
      this.companyDropdownTarget.style.display = 'flex'
      navItem.classList.add('is-open')
    }
  }

  toggleSubsidyDropdown(event) {
    event.stopPropagation()
    const navItem = event.currentTarget.closest('.site-header__nav-item')
    const isVisible = this.hasSubsidyDropdownTarget && this.subsidyDropdownTarget.style.display === 'block'

    this.closeAllDropdowns()

    if (!isVisible && this.hasSubsidyDropdownTarget) {
      this.subsidyDropdownTarget.style.display = 'block'
      navItem.classList.add('is-open')
    }
  }

  toggleColumnDropdown(event) {
    event.stopPropagation()
    const navItem = event.currentTarget.closest('.site-header__nav-item')
    const isVisible = this.hasColumnDropdownTarget && this.columnDropdownTarget.style.display === 'block'

    this.closeAllDropdowns()

    if (!isVisible && this.hasColumnDropdownTarget) {
      this.columnDropdownTarget.style.display = 'block'
      navItem.classList.add('is-open')
    }
  }

  closeAllDropdowns() {
    // すべてのis-openクラスを削除
    const openNavItems = this.element.querySelectorAll('.site-header__nav-item.is-open')
    openNavItems.forEach(item => item.classList.remove('is-open'))

    if (this.hasCompanyDropdownTarget) {
      this.companyDropdownTarget.style.display = 'none'
      // すべての地域のactiveクラスを削除
      const regions = this.companyDropdownTarget.querySelectorAll('.site-header__dropdown-region')
      regions.forEach(region => region.classList.remove('active'))
      // すべての都道府県リストを非表示
      const prefectureLists = this.companyDropdownTarget.querySelectorAll('.site-header__dropdown-prefecture-list')
      prefectureLists.forEach(list => list.classList.remove('active'))
    }
    if (this.hasSubsidyDropdownTarget) {
      this.subsidyDropdownTarget.style.display = 'none'
    }
    if (this.hasColumnDropdownTarget) {
      this.columnDropdownTarget.style.display = 'none'
    }
  }

  showPrefectures(event) {
    const regionElement = event.currentTarget
    const regionName = regionElement.dataset.region

    // すべての地域のactiveクラスを削除
    const regions = this.companyDropdownTarget.querySelectorAll('.site-header__dropdown-region')
    regions.forEach(region => region.classList.remove('active'))

    // 選択された地域にactiveクラスを追加
    regionElement.classList.add('active')

    // すべての都道府県リストを非表示
    const prefectureLists = this.companyDropdownTarget.querySelectorAll('.site-header__dropdown-prefecture-list')
    prefectureLists.forEach(list => list.classList.remove('active'))

    // 選択された地域の都道府県リストを表示
    const targetList = this.companyDropdownTarget.querySelector(`[data-region="${regionName}"].site-header__dropdown-prefecture-list`)
    if (targetList) {
      targetList.classList.add('active')
    }
  }
})

// SP用メニューのStimulus Controller
app.register('refosumu--sp-menu', class extends Controller {
  static targets = [
    'drawer',
    'subsidy-areaExpandable'
  ]

  toggle() {
    if (this.hasDrawerTarget) {
      this.drawerTarget.classList.toggle('active')

      // メニューが開いているときは背景のスクロールを無効化
      if (this.drawerTarget.classList.contains('active')) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  }

  close() {
    if (this.hasDrawerTarget) {
      this.drawerTarget.classList.remove('active')
      // メニューを閉じたときは背景のスクロールを有効化
      document.body.style.overflow = ''
    }
  }

  toggleExpandable(event) {
    const button = event.currentTarget
    const expandableId = button.dataset.expandable
    const content = this.element.querySelector(`[data-refosumu--sp-menu-target="${expandableId}Expandable"]`)

    // ヘッダーにactiveクラスをトグル
    button.classList.toggle('active')

    if (content) {
      content.classList.toggle('active')
    }
  }

  toggleRegion(event) {
    const header = event.currentTarget
    const regionId = header.dataset.region
    const content = this.element.querySelector(`[data-refosumu--sp-menu-target="region-${regionId}"]`)

    header.classList.toggle('active')
    if (content) {
      content.classList.toggle('active')
    }
  }
})
